import { useTranslation } from '../../lib/useTranslation';
import './receiptCapture.css';

/** PDFs stay as files; they are never embedded into an image or executable preview. */
export default function ReceiptFilePreview({ value, fileName, className }: { value: string; fileName?: string; className?: string }) {
  const t = useTranslation();
  if (!value.startsWith('data:application/pdf;')) {
    return <img className={className} src={value} alt={t('costs.capture.previewAlt.receipt')} />;
  }
  return <span className={`cst-receipt-file${className ? ` ${className}` : ''}`}>
    <span className="material-symbols-rounded" aria-hidden="true">picture_as_pdf</span>
    <strong>{t('costs.capture.pdfSelected')}</strong>
    {fileName && <span>{fileName}</span>}
  </span>;
}
